import React, { useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { IonPage } from "@ionic/react";
import { Button, Typography, Row, Col, Form, Breadcrumb, Space, Spin, Input, notification, Result } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

//
import log from "../../../utils/log";
import c from "../../../utils/common";
import moment from "moment-timezone";
import metaData from "../../../data/metaData";
import _ from "lodash";
import { showErrMsg } from "../../../utils/error";
import axios from "axios";
import https from "https";

//
import Overview from "../../../components/Product/Overview";
import PageHeader from "../../../components/PageHeader";

//
import useProduct from "../../../hooks/useProduct";
import useProductStore from "../../../states/useProduct";
import useAuthStore from "../../../states/useAuth";

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const SingleProduct = () => {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams(); // Get the :id parameter from the URL
  const { resetProduct } = useProductStore();
  const { auth } = useAuthStore();
  const { getSingleProduct, updateProductProduct, createProduct } = useProduct();

  //Sider
  const [collapsed, setCollapsed] = useState(false);

  const [productForm] = Form.useForm();
  const [brandForm] = Form.useForm();
  const [companyForm] = Form.useForm();

  const [product, setProduct] = useState();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isFetchingSingleProduct, setIsFetchingSingleProduct] = useState(false);
  const [isShowErrorPage, setIsShowErrorPage] = useState(false);

  const getSingleProductData = async () => {
    //setActiveTab
    let queryURL = location.search || undefined;
    log.debug(queryURL);
    // const queryParams = c.parseQueryToJSON(queryURL);
    // const { tab } = queryParams;
    // log.debug(tab);
    // setActiveTab(tab);

    //
    log.debug(id);
    if (id == "new") {
      return;
    }

    let result;

    try {
      setIsFetchingSingleProduct(true);
      result = await getSingleProduct(id, true, false);

      log.debug(result);
      setProduct(result);
    } catch (error) {
      setIsShowErrorPage(true);
      notification.error({
        message: (
          <Title style={{ margin: 0 }} level={4}>
            Error
          </Title>
        ),
        description: <Text strong>Please refresh this page</Text>,
      });
    } finally {
      setIsFetchingSingleProduct(false);
    }
  };

  const updateProductData = (newData) => {
    setProduct((prev) => {
      const updated = _.merge({}, prev, newData);
      log.debug(prev);
      log.debug(newData);

      // Explicitly overwrite certain fields instead of merging
      if ("redeemShopIds" in newData.product) {
        updated.redeemShopIds = newData.product.redeemShopIds;
      }

      log.debug(updated);
      return updated;
    });
  };

  const onChangeQty = async (key, newValue) => {
    // Log the change and call the API
    log.debug(key, newValue);

    try {
      // Make the API call
      await axios.patch(
        metaData.serverURL + "product",
        { qty: { [key]: newValue } },
        {
          params: { id: product?.id }, // Pass the request ID as a query parameter if needed
          headers: { Authorization: auth.jwt },
          httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
        }
      );

      notification.success({ message: "Success" });
      getSingleProductData();
    } catch (error) {
      showErrMsg(error);
    }
  };

  const onChangeRedeemShopIds = async (newValue) => {
    // Log the change and call the API
    log.debug(newValue);

    try {
      // Make the API call
      await axios.patch(
        metaData.serverURL + "product",
        { redeemShopIds: newValue },
        {
          params: { id: product?.id }, // Pass the request ID as a query parameter if needed
          headers: { Authorization: auth.jwt },
          httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
        }
      );

      notification.success({ message: "Success" });
      getSingleProductData();
    } catch (error) {
      showErrMsg(error);
    }
  };

  const registerOnRefreshEvent = () => {
    const handleBeforeUnload = () => {
      resetProduct(); // Reset the state when the page is refreshed or closed
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload); // Properly remove the listener
    };
  };

  useEffect(() => {
    return registerOnRefreshEvent(); // Cleanup when component unmounts
  }, []);

  useEffect(() => {
    getSingleProductData();
  }, [id]);

  return (
    <div
      style={{
        margin: "0 auto",
        // background: "var(--ion-color-step-50)",
      }}
    >
      <Spin
        spinning={isFetchingSingleProduct}
        // percent="auto"
        indicator={<Loading3QuartersOutlined spin style={{ color: "white", fontSize: "2rem" }} />}
        fullscreen
      />

      {isShowErrorPage ? (
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button
              type="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              Refresh
            </Button>
          }
        />
      ) : (
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <a
                    onClick={() => {
                      history.push("/merchantUser/product");
                    }}
                  >
                    Product List
                  </a>
                ),
              },
              {
                title: <a>Product</a>,
              },
            ]}
          />

          <PageHeader
            title={<Space>Product Detail</Space>}
            isSticky
            // actionGroup={
            //   <Space>
            //     <Button
            //       size="large"
            //       type="primary"
            //       style={{ marginRight: "1.5rem", width: "7.5rem" }}
            //       onClick={async () => {
            //         // let data = await parseFormData();
            //       }}
            //     >
            //       Edit
            //     </Button>
            //   </Space>
            // }
            onBack={() => {
              history.goBack();
            }}
          />

          {isFetchingSingleProduct ? null : (
            <>
              <Row
                style={{
                  // background: "var(--ion-color-step-50)",
                  paddingTop: "2rem",
                }}
              >
                <Overview
                  state={{
                    data: product,
                    onChange: updateProductData,
                  }}
                  onChangeQty={onChangeQty}
                  onChangeRedeemShopIds={onChangeRedeemShopIds}
                />
              </Row>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SingleProduct;
